module.exports = "/assets/src/assets/Boîte aux lettres.svg";